import {
  StyleSheet,
  Text,
  View,
  Image,
  FlatList,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { getLoginData } from "../../../utility/AppStoreData";
import { getTransaction } from "../../../services/profileAPI";
import { toast } from "react-toastify";
import { BeltImages } from "../../../Api/configs";
import Skeletons from "../../../Components/skeleton-components/Skeletons";
import NoDataFound from "../../../Components/NoDataFound";
import Header from "./Common/Header";
import { ScreenBGGradientView } from "../../../common/CommonView";

export default function ViewTrasactionHistory() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [accessToken, setAccessToken] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const isSmallOrXS =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  let skeletonCards = Array(10).fill(0);

  async function getLoginUserData() {
    const data = await getLoginData();
    if (data) {
      setAccessToken(data.AccessToken);
      await getTransactions(data.AccessToken);
    }
  }
  useEffect(() => {
    getLoginUserData();
  }, []);

  async function getTransactions(accessToken) {
    setShowLoader(true);
    try {
      const data = await getTransaction(accessToken);
      if (data.statusCode === 200 || data.statusCode === 201) {
        setTransactionData(data.transactions);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  }

  const renderTransactionItem = ({ item, index }) => {
    const formattedDate = new Date(item.date).toLocaleDateString("en-GB");

    // Check if it's a belt-to-belt conversion (e.g., "1 Silver to 10 Bronze")
    const isBeltConversion = item.beltType && item.beltType.includes(" to ");

    // Determine transaction type
    let transactionType = "";
    if (isBeltConversion) {
      transactionType = "Belt Conversion";
    } else if (item.tokens > 0) {
      transactionType = "Belt Purchase";
    } else if (item.amount && item.amount !== "" && item.amount !== "-") {
      transactionType = "Belt to Credit";
    } else {
      transactionType = "-";
    }

    // Extract belt types for conversion
    let fromText = "";
    let toText = "";
    let fromBeltIcon = null;
    let toBeltIcon = null;

    if (isBeltConversion) {
      // Parse conversion format: "1 Silver to 10 Bronze"
      const parts = item.beltType.split(" to ");
      const fromParts = parts[0].trim().split(" "); // ["1", "Silver"]
      const toParts = parts[1].trim().split(" "); // ["10", "Bronze"]

      const fromAmount = fromParts[0];
      const fromBelt = fromParts.slice(1).join(" ");
      const toAmount = toParts[0];
      const toBelt = toParts.slice(1).join(" ");

      fromText = `${fromAmount} ${fromBelt}`;
      toText = `${toAmount} ${toBelt}`;
      fromBeltIcon = BeltImages[fromBelt];
      toBeltIcon = BeltImages[toBelt];
    } else if (item.beltType) {
      // Single belt type (Buy or Convert to Credit)
      fromBeltIcon = BeltImages[item.beltType];
    }

    return (
      <View key={index} style={{ paddingHorizontal: 12 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: 40,
            paddingVertical: 10,
          }}
        >
          <View style={{ flex: 1, minWidth: 120 }}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}>
              {formattedDate}
            </Text>
          </View>

          <View style={{ flex: 1, minWidth: 120 }}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}>
              {transactionType}
            </Text>
          </View>

          <View style={{ flex: 1, minWidth: 120 }}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}>
              {item.amount === "" ? "-" : item.amount}
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              gap: 5,
              alignItems: "center",
              flex: 1,
              minWidth: 120,
            }}
          >
            {isBeltConversion ? (
              <>
                <Image
                  source={fromBeltIcon}
                  style={{
                    height: 30,
                    width: 25,
                    resizeMode: "contain",
                  }}
                />
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: "white" },
                  ]}
                >
                  {fromText}
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: "white", marginHorizontal: 4 },
                  ]}
                >
                  →
                </Text>
                <Image
                  source={toBeltIcon}
                  style={{
                    height: 30,
                    width: 25,
                    resizeMode: "contain",
                  }}
                />
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: "white" },
                  ]}
                >
                  {toText}
                </Text>
              </>
            ) : (
              <>
                {fromBeltIcon && (
                  <Image
                    source={fromBeltIcon}
                    style={{
                      height: 30,
                      width: 25,
                      resizeMode: "contain",
                    }}
                  />
                )}
                <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "white" }]}>
                  {item.belts === 0 ? "-" : item.belts}
                </Text>
              </>
            )}
          </View>

          <View style={{ flex: 1, minWidth: 120 }}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: "white", textAlign: "center" },
              ]}
            >
              {item.tokens === 0 ? "-" : item.tokens}
            </Text>
          </View>
        </View>
        <View style={[styles.centerDivider, { marginVertical: 10 }]} />
      </View>
    );
  };

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* Mobile Device navigation Header */}
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={styles.container}>
        {/* Header with back button */}
        {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
          <>
            {/* Mobile Layout - First Row: Back button + Transaction History */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 12,
                marginBottom: 15,
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                }}
              >
                <LinearGradient
                  colors={["#1F2937", "#111827"]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                  style={{
                    width: 44,
                    height: 44,
                    padding: 6,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 8,
                    borderWidth: 0.8,
                    borderColor: "#374151",
                  }}
                >
                  <Image
                    source={AppImages.icArrowLeft}
                    style={{
                      height: 24,
                      width: 24,
                      tintColor: AppColors.white,
                    }}
                    resizeMode="contain"
                  />
                </LinearGradient>
              </TouchableOpacity>
              {showLoader ? (
                <Skeletons
                  height={24}
                  width={"200px"}
                  style={{ borderRadius: 10 }}
                />
              ) : (
                <Text style={[AppFontStyle.BOLD_ANYBODY_16, {}]}>
                  Transaction History
                </Text>
              )}
            </View>
          </>
        ) : (
          /* Desktop Layout - Original single row */
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 12,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
            >
              <LinearGradient
                colors={["#1F2937", "#111827"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                  width: 44,
                  height: 44,
                  padding: 6,
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 8,
                  borderWidth: 0.8,
                  borderColor: "#374151",
                }}
              >
                <Image
                  source={AppImages.icArrowLeft}
                  style={{
                    height: 24,
                    width: 24,
                    tintColor: AppColors.white,
                  }}
                  resizeMode="contain"
                />
              </LinearGradient>
            </TouchableOpacity>
            <View>
              {showLoader ? (
                <Skeletons
                  height={45}
                  width={"250px"}
                  style={{
                    borderRadius: 10,
                  }}
                />
              ) : (
                <Text style={[AppFontStyle.BOLD_ANYBODY_32, {}]}>
                  Transaction History
                </Text>
              )}
            </View>
          </View>
        )}

        {/* Separator - Only show on desktop/web */}
        {deviceSize !== DEVICE_SIZES.XS && deviceSize !== DEVICE_SIZES.SM && (
          <View
            style={{
              width: "100%",
              height: 1,
              backgroundColor: "#374151",
              marginTop: 20,
              marginBottom: 0,
            }}
          />
        )}

        <ScrollView
          horizontal={isSmallOrXS}
          contentContainerStyle={{
            flexDirection: "row",
            flexGrow: 1,
          }}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          style={{
            marginTop:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 15
                : 20,
          }}
        >
          <View style={[styles.transactionDataBeltView]}>
            {showLoader ? (
              <Skeletons height={40} width={"100%"} />
            ) : (
              <LinearGradient
                colors={["#1F2937", "#111827"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingVertical: 11,
                  paddingHorizontal: 12,
                  borderRadius: 8,
                  borderWidth: 0.8,
                  borderColor: "#374151",
                }}
              >
                {["Date", "Type", "Amount", "Belts Converted", "Tokens"].map(
                  (item, index) => {
                    const isTokensColumn = item === "Tokens";
                    return (
                      <View key={index} style={{ flex: 1 }}>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                              ? AppFontStyle.REGULAR_ANYBODY_14
                              : AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                              minWidth: 120,
                              textAlign: isTokensColumn ? "center" : "left",
                            },
                          ]}
                        >
                          {item}
                        </Text>
                      </View>
                    );
                  }
                )}
              </LinearGradient>
            )}
            {showLoader ? (
              skeletonCards.map((index) => (
                <Skeletons
                  height={40}
                  width={"100%"}
                  style={{ marginTop: 10 }}
                />
              ))
            ) : transactionData.length === 0 ? (
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 300,
                  marginRight:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 275
                      : 0,
                }}
              >
                <NoDataFound text="No Transaction Found" />
              </View>
            ) : (
              <View>
                <FlatList
                  data={transactionData}
                  renderItem={({ item, index }) => {
                    return renderTransactionItem({ item, index });
                  }}
                  keyExtractor={(item) => item.id}
                />
              </View>
            )}
          </View>
        </ScrollView>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    transactionDataBeltView: {
      width: "100%",
      borderRadius: 10,
      paddingBottom: 15,
      gap: 10,
    },
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
      // marginHorizontal: 20,
    },
    buttonStyle: {
      borderRadius: 10,
      height: 36,
      width: 180,
      flexDirection: "row",
      gap: 8,
      justifyContent: "center",
      alignItems: "center",
    },
    headerWrapper: {
      flexDirection: "row",
      alignItems: "center",
      marginTop: 10,
    },
    headerTextLeft: {
      flex: 1.5,
    },
    headerTextRight: {
      flex: 0.5,
      alignSelf: "center",
      textAlign: "center",
    },
    centerDivider: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      height: 2,
    },
    itemStyle: {
      marginVertical: 5,
    },
    itemTextWrapper: {
      alignSelf: "center",
      gap: 5,
      marginStart: 35,
      marginEnd: 35,
    },
    itemLeft: {
      flexDirection: "row",
      flex: 1.5,
    },
    itemRight: {
      flex: 0.5,
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    backButtonStyle: {
      height: 40,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      alignSelf: "flex-start",
      marginVertical: 20,
      marginHorizontal: 20,
    },
    itemWrapper: {
      flexDirection: "row",
      paddingVertical: 12,
      flexWrap: "wrap",
      gap: 20,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 180,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "column",
        alignItems: "center",
        marginTop: 10,
        gap: 10,
      },
      headerTextLeft: {
        flex: 1,
      },
      headerTextRight: {
        flex: 1,
        alignSelf: "flex-end",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1,
      },
      itemRight: {
        flex: 1,
        alignSelf: "flex-end",
        justifyContent: "flex-end",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "column",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
  }
);
